import React, { useEffect, useState } from 'react';
import FileUpload from './FileUpload/FileUpload';

const CourseDetails = ({ onDataChange, initialValues = {} }) => {
    const [title, setTitle] = useState(initialValues.title || '');
    const [description, setDescription] = useState(initialValues.description || '');
    const [price, setPrice] = useState(initialValues.price || '');
    const [hours, setHours] = useState(initialValues.hours || '');
    const [minutes, setMinutes] = useState(initialValues.minutes || '');
    const [startDate, setStartDate] = useState(initialValues.startDate || '');
    const [endDate, setEndDate] = useState(initialValues.endDate || '');

    const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

    useEffect(() => {
        setTitle(initialValues.title || '');
        setDescription(initialValues.description || '');
        setPrice(initialValues.price || '');
        const durationParts = (initialValues.duration || '').split(' ');
        const parsedHours = durationParts[0] || '';
        const parsedMinutes = durationParts[2] || '';
        setHours(parsedHours);
        setMinutes(parsedMinutes);
        setStartDate(initialValues.startDate || '');
        setEndDate(initialValues.endDate || '');
    }, [initialValues]);

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
        notifyParent();
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
        notifyParent();
    };

    const handlePriceChange = (e) => {
        setPrice(e.target.value);
        notifyParent();
    };

    const handleHoursChange = (e) => {
        setHours(e.target.value);
        notifyParent();
    };

    const handleMinutesChange = (e) => {
        setMinutes(e.target.value);
        notifyParent();
    };

    const handleStartDateChange = (e) => {
        const selectedDate = e.target.value;
        if (selectedDate >= today) {
            setStartDate(selectedDate);
        } else {
            // Optionally show an error or reset the field
            alert('Start date cannot be in the past.');
        }
        notifyParent();
    };

    const handleEndDateChange = (e) => {
        const selectedDate = e.target.value;
        if (selectedDate >= today) {
            setEndDate(selectedDate);
        } else {
            // Optionally show an error or reset the field
            alert('End date cannot be in the past.');
        }
        notifyParent();
    };

    const notifyParent = () => {
        let duration = '';
        if (hours && minutes) {
            duration = `${hours} hours ${minutes} minutes`;
        }
        onDataChange({ title, description, price, duration, startDate, endDate });
    };

    return (
        <div>
            <h3>Course Details</h3>
            <input
                type="text"
                placeholder="Course Title"
                value={title}
                onChange={handleTitleChange}
            />
            <textarea
                placeholder="Course Description"
                value={description}
                onChange={handleDescriptionChange}
            ></textarea>
            <input
                type="number"
                placeholder="Price"
                value={price}
                onChange={handlePriceChange}
            />
            <div>
                <input
                    type="number"
                    placeholder="Hours"
                    value={hours}
                    onChange={handleHoursChange}
                />
                <input
                    type="number"
                    placeholder="Minutes"
                    value={minutes}
                    onChange={handleMinutesChange}
                />
            </div>
            <input
                type="date"
                placeholder="Start Date"
                value={startDate}
                onChange={handleStartDateChange}
                min={today} // Restrict to today onwards
            />
            <input
                type="date"
                placeholder="End Date"
                value={endDate}
                onChange={handleEndDateChange}
                min={today} // Restrict to today onwards
            />
            <FileUpload
                label="Choose Files"
            />
        </div>
    );
};

export default CourseDetails;
